export default __webpack_public_path__ + "static/media/desktop-etapa2.ed34a2f0.jpg";